import { render } from "./StructureViewer.vue?vue&type=template&id=1f4d1ac0&scoped=true"
import script from "./StructureViewer.vue?vue&type=script&lang=js"
export * from "./StructureViewer.vue?vue&type=script&lang=js"

import "./StructureViewer.vue?vue&type=style&index=0&id=1f4d1ac0&scoped=true&lang=scss"
import "./StructureViewer.vue?vue&type=style&index=1&id=1f4d1ac0&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4d1ac0"]])

export default __exports__